import { compareAsc } from "date-fns";
import { parse } from "date-fns/esm";

export const compareNull = (a: any, b: any) => {
  if (a === null && b === null) return 0;
  if (a === null) return -1;
  return 1;
};

export const compareNullableDates = (a: string | null, b: string | null) =>
  a === null || b === null
    ? compareNull(a, b)
    : compareAsc(parse(a, "M/d/y", new Date()), parse(b, "M/d/y", new Date()));
